import { getLocale } from "../runtime";

const sv_testing = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Testar ${inputs.name}.`
};

const testing = /** @type {(inputs: {name: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_testing(inputs)
	return "testing";
};

export { testing as "testing" };